import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextAlignmentJustify';
/** Renders an SVG icon. */
const SvgTextAlignmentJustify = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M28 5a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h22a1 1 0 0 0 1-1m0 5a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h22a1 1 0 0 0 1-1m0 6a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1m0 6a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1m-12 5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1"
      />
    </svg>
  );
};
SvgTextAlignmentJustify.displayName = displayName;
export default SvgTextAlignmentJustify;
